/**
 * reCAPTCHA v2 invisible 封裝（狂一鍋 interval 訂位用）。
 *
 * 對外只有一個 getRecaptchaToken()：回傳 Promise<string>，
 * 拿不到 token 時回空字串而不是丟例外——是否放行由後端決定
 * （後端 RECAPTCHA_KEY 有值才驗，dev 清空即放行）。
 *
 * 前端不硬擋的理由：reCAPTCHA 在 IP 位址或未授權網域拿不到 token，
 * 若前端擋死，開發／內網測試就完全訂不了位。
 */
const RC_CONTAINER_ID = 'interval-recaptcha-container';
let widgetId = null;
let pendingResolve = null;
let loading = false;
function grecaptcha() {
    return window.grecaptcha;
}
/**
 * 掛載 invisible widget。重複呼叫安全（已掛載就直接返回）。
 *
 * 必須自己插入容器 div：invisible 模式仍需要一個實體節點來承載 widget，
 * 沒有容器時 grecaptcha.render 會丟例外。
 */
export function initRecaptcha(siteKey) {
    if (!siteKey || widgetId !== null || loading) {
        return;
    }
    loading = true;
    if (!document.getElementById(RC_CONTAINER_ID)) {
        const div = document.createElement('div');
        div.id = RC_CONTAINER_ID;
        div.style.display = 'none';
        document.body.appendChild(div);
    }
    const render = () => {
        const rc = grecaptcha();
        if (rc && rc.render && widgetId === null) {
            try {
                widgetId = rc.render(RC_CONTAINER_ID, {
                    sitekey: siteKey,
                    size: 'invisible',
                    callback: (token) => {
                        const resolve = pendingResolve;
                        pendingResolve = null;
                        try {
                            rc.reset(widgetId);
                        }
                        catch (e) {
                            // reset 失敗不影響本次結果，下次 execute 前 Google 會自行處理
                        }
                        if (resolve) {
                            resolve(token);
                        }
                    },
                    'error-callback': () => {
                        const resolve = pendingResolve;
                        pendingResolve = null;
                        if (resolve) {
                            resolve('');
                        }
                    },
                });
            }
            catch (e) {
                // 網域未授權等情況會丟例外；維持 widgetId = null，getRecaptchaToken 會回空字串
            }
        }
        if (widgetId === null) {
            setTimeout(render, 300);
        }
    };
    if (!grecaptcha()) {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }
    render();
}
/**
 * 取一次性 token。
 *
 * 8 秒逾時保險：reCAPTCHA 無回應時（載入失敗、網域未授權）
 * 若沒有這道保險，整個訂位流程會永遠卡在「送出中…」。
 */
export function getRecaptchaToken() {
    return new Promise((resolve) => {
        let done = false;
        const finish = (token) => {
            if (done) {
                return;
            }
            done = true;
            pendingResolve = null;
            resolve(token);
        };
        const rc = grecaptcha();
        if (widgetId === null || !rc) {
            finish('');
            return;
        }
        pendingResolve = finish;
        try {
            rc.execute(widgetId);
        }
        catch (e) {
            finish('');
        }
        setTimeout(() => finish(''), 8000);
    });
}
